import { Component, forwardRef, HostBinding, Injector, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-date',
  templateUrl: './r-date.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RDateComponent),
      multi: true
    }
  ]
})
export class RDateComponent extends RenderComponentBase {
  static KEY = 'r-d-date';

  // @HostBinding('style.float') float = 'left';

  constructor(injector: Injector) {
    super(injector);
  }

  dateFormat = 'yyyy-MM-dd';

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.allowClear !== 'boolean') {
      config.allowClear = true;
    }
    // config.value = '2021-12-12';
    // if (config.value) {
    //   config.value = new Date();
    //   console.log(config.value, ' config.value');
    // }
  }
}
